import {defineMessages, FormattedMessage} from 'react-intl';
import {view} from '@sail/ui';
import {MetaRow} from './MetaRow';

const messages = defineMessages({
  translatedConversation: {
    id: 'conversations_ui.chat.row.translationRow',
    description: "Message to show in a conversation when it's translated.",
    defaultMessage: 'Agent responses are translated from English',
  },
});

type Props = {
  MetaRowComponent?: typeof MetaRow;
};

export const TranslationRow = ({MetaRowComponent = MetaRow}: Props) => (
  <view.div data-testid="translation-row">
    <MetaRowComponent>
      <FormattedMessage {...messages.translatedConversation} />
    </MetaRowComponent>
  </view.div>
);

export default TranslationRow;
